import React from 'react';
import { GraduationCap, Award, Heart, Users } from 'lucide-react';
import { doctorInfo, contactInfo } from '../data/mock';

const AboutSection = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent(contactInfo.whatsappMessage);
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${message}`;
    window.location.href = url;
  };
  const achievements = [
    {
      icon: GraduationCap,
      title: "Excelencia Académica",
      description: "Formación de primer nivel en UANL y experiencia internacional en USA y Argentina"
    },
    {
      icon: Award,
      title: "Certificado CMDx",
      description: "Certificado por el Consejo Mexicano de Dermatología 2025"
    },
    {
      icon: Heart,
      title: "Atención Centrada en el Paciente",
      description: "Enfoque compasivo con planes de tratamiento personalizados"
    },
    {
      icon: Users,
      title: "Equipo Especializado",
      description: "Tecnología de punta en laser, depilación y rejuvenecimiento"
    }
  ];

  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;

  return (
    <section id="about" className="py-24 bg-page">
      <div className="container">
        <div className="ai-grid items-start">
          {/* Doctor Image */}
          <div className="space-y-6">
            <img 
              src={doctorInfo.image} 
              alt={doctorInfo.name}
              className="w-full max-w-md mx-auto rounded-2xl shadow-lg"
            />
            
            {/* Credentials Card */}
            <div className="voice-card accent-purple text-center">
              <h3 className="voice-card-title">{doctorInfo.name}</h3>
              <p className="body-small text-secondary mb-2">{doctorInfo.credentials}</p>
              <p className="caption">{doctorInfo.experience}</p>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="heading-1 mb-6">Conoce al Dr. Adrián Cuéllar Barboza</h2>
              <p className="body-large text-secondary mb-6">
                {doctorInfo.bio}
              </p>
              
              <div className="space-y-3">
                <h3 className="heading-3">Áreas de expertise</h3>
                <div className="flex flex-wrap gap-2">
                  {doctorInfo.specialties.map((specialty, index) => (
                    <span key={index} className="btn-tag">
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Education */}
            <div>
              <h3 className="heading-3 mb-4">Formación Académica y Profesional</h3>
              <div className="space-y-3">
                {doctorInfo.education.map((edu, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent-blue-400 mt-2"></div>
                    <span className="body-medium">{edu}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Certifications */}
            <div>
              <h3 className="heading-3 mb-4">Certificaciones y Reconocimientos</h3>
              <div className="space-y-3">
                {doctorInfo.certifications.map((cert, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent-green-200 mt-2"></div>
                    <span className="body-medium">{cert}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="pt-4">
              <a href={whatsappUrl} className="btn-primary inline-block">
                Agendar Consulta
              </a>
            </div>
          </div>
        </div>

        {/* Achievements Grid */}
        <div className="mt-24">
          <h3 className="heading-2 text-center mb-12">¿Por qué elegir al Dr. Adrián Cuéllar?</h3>
          <div className="voice-grid">
            {achievements.map((achievement, index) => {
              const IconComponent = achievement.icon;
              const accentClasses = ['accent-blue', 'accent-orange', 'accent-green', 'accent-pink'];
              const accentClass = accentClasses[index % accentClasses.length];
              
              return (
                <div key={index} className={`voice-card ${accentClass} text-center hover-lift`}>
                  <div className="w-16 h-16 rounded-full bg-white/30 flex items-center justify-center mx-auto mb-4">
                    <IconComponent size={32} className="text-primary" />
                  </div>
                  <h4 className="voice-card-title mb-2">{achievement.title}</h4>
                  <p className="voice-card-description">{achievement.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;